var _clipPath, _linearGradient, _linearGradient2, _clipPath2, _linearGradient3, _clipPath3, _linearGradient4, _radialGradient, _clipPath4, _radialGradient2, _radialGradient3, _radialGradient4, _g, _path, _g2, _path2, _g3, _g4, _g5, _path3, _g6, _path4, _path5, _g7, _g8, _g9, _circle, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 192 192",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 88
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 29.337,
    x2: 81.837,
    y1: 75.021,
    y2: 44.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 110.872,
    x2: 52.538,
    y1: 164.495,
    y2: 130.329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 121.858,
    x2: 136.547,
    y1: 49.804,
    y2: 114.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 92.176,
    cy: 55.948,
    gradientUnits: "userSpaceOnUse",
    r: 84.078,
    xlinkHref: "#a"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 21.875,
    cy: 48.52,
    gradientUnits: "userSpaceOnUse",
    r: 78.044,
    xlinkHref: "#a"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 95.844,
    cy: 96.138,
    gradientUnits: "userSpaceOnUse",
    r: 87.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 34.286,
    cy: 32.014,
    gradientUnits: "userSpaceOnUse",
    r: 176.746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.39L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.39L96 56h88V8z",
    fill: "url(#c)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M62.31 115.65L22.48 47.34l-.58 1 39.54 67.8z",
    fill: "#3e2723",
    fillOpacity: 0.15
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z",
    fill: "url(#d)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M129.84 117.33l-.83-.48L90.62 184h1.15l38.1-66.64z",
    fill: "#263238",
    fillOpacity: 0.15
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#f)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#f)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.39L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.39L96 56h88V8z",
    fill: "url(#c)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M96 56v20.95L174.4 56z",
    fill: "url(#h)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z",
    fill: "url(#d)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z",
    fill: "url(#j)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M91.83 183.89l20.96-78.2L130.65 116z",
    fill: "url(#k)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "#f1f1f1",
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "#4285f4",
    r: 32
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 55c-22.09 0-40 17.91-40 40v1c0-22.09 17.91-40 40-40h88v-1z",
    fill: "#3e2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 116c-6.92 11.94-19.81 20-34.6 20-14.8 0-27.69-8.06-34.61-20h-.04L8 24.48v1L61.36 117h.04c6.92 11.94 19.81 20 34.61 20 14.79 0 27.68-8.05 34.6-20h.05v-1z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.09 0 40-17.91 40-40s-17.91-40-40-40z",
    fill: "#3e2723",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 117.33c3.4-5.88 5.37-12.68 5.37-19.96 0-4.22-.66-8.28-1.87-12.09.95 3.42 1.5 7.01 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16l38.09-66.64z",
    fill: "#fff",
    fillOpacity: 0.2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 9c48.43 0 87.72 39.13 87.99 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 183c48.43 0 87.72-39.13 87.99-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5C8.28 143.87 47.57 183 96 183z",
    fill: "#3e2723",
    fillOpacity: 0.15
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "url(#l)",
    r: 88
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v192H0z",
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.8b7dff33.svg";
export { ForwardRef as ReactComponent };